/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 応答ステータス
 */
export type AcceptRequestResponseEmsEnum =
  (typeof AcceptRequestResponseEmsEnum)[keyof typeof AcceptRequestResponseEmsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AcceptRequestResponseEmsEnum = {
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
  OTHER: 'OTHER',
} as const;
